import { render, staticRenderFns } from "./ypzDetail.vue?vue&type=template&id=bfc966f8&scoped=true&"
import script from "./ypzDetail.vue?vue&type=script&lang=js&"
export * from "./ypzDetail.vue?vue&type=script&lang=js&"
import style0 from "./ypzDetail.vue?vue&type=style&index=0&id=bfc966f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc966f8",
  null
  
)

export default component.exports